import { useEffect, useRef } from 'react';

const useAbortController = (key) => {
    const keyRef = useRef(null);
    const controllerRef = useRef(null);

    useEffect(
        () => () => controllerRef.current && controllerRef.current.abort(),
        [],
    );

    if (keyRef.current === key) return controllerRef.current;

    if (controllerRef.current) controllerRef.current.abort();
    controllerRef.current = new AbortController();
    keyRef.current = key;

    return controllerRef.current;
};

export default useAbortController;
